import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Input.css';

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const inputClasses = classNames(css.input, className);

  return (
    <input
      type={type}
      className={inputClasses}
      ref={ref}
      {...props}
    />
  );
});

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
};

Input.displayName = 'Input';

export { Input }; 